module.exports = __webpack_public_path__ + "img/stats_mobile_es.7cd63cf.webp";